import { useEffect, useState } from "react";
import { Clock, CheckCircle2, Minus } from "lucide-react";

export function formatDuration(seconds) {
  if (seconds == null || isNaN(seconds)) return "—";
  const s = Math.max(0, Math.floor(seconds));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const parts = [];
  if (d) parts.push(`${d}d`);
  if (h || d) parts.push(`${h}h`);
  parts.push(`${m}m`);
  if (!d) parts.push(`${sec}s`);
  return parts.join(" ");
}

// Timer measures elapsed time from "In Progress" (started_at) to
// "Processed for Delivery" (dispatch_at). Ticks live while running.
export default function JobTimer({ job, className = "" }) {
  const [now, setNow] = useState(Date.now());

  const running = job.timer_running;
  useEffect(() => {
    if (!running) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [running]);

  // Not started yet
  if (!job.timer_started) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 text-zinc-400 font-medium ${className}`}
        data-testid={`job-timer-${job.id}`}
      >
        <Minus size={14} /> Not started
      </span>
    );
  }

  let seconds;
  const stopped = !running;
  if (running && job.timer_running_since) {
    // Resume from banked time and keep counting live.
    seconds = (job.timer_accumulated || 0) + (now - new Date(job.timer_running_since).getTime()) / 1000;
  } else {
    seconds = job.timer_seconds;
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 tabular-nums font-semibold ${
        stopped ? "text-emerald-700" : "text-brand"
      } ${className}`}
      data-testid={`job-timer-${job.id}`}
    >
      {stopped ? <CheckCircle2 size={14} /> : <Clock size={14} />}
      {formatDuration(seconds)}
    </span>
  );
}
